import { useEffect, useState } from "react";

const Background = () => {
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (event) => {
      setMousePos({ x: event.clientX, y: event.clientY });
    };
    window.addEventListener("mousemove", handleMouseMove);
    return () => window.removeEventListener("mousemove", handleMouseMove);
  }, []);

  const interactiveGradientStyle = {
    background: `radial-gradient(800px at ${mousePos.x}px ${mousePos.y}px, rgba(14, 165, 233, 0.15), transparent 80%)`,
  };

  return (
    <div className="absolute inset-0 z-0 bg-slate-50 overflow-hidden">
      <div className="absolute -top-1/4 -left-1/4 w-1/2 h-1/2 bg-gradient-radial from-cyan-100/80 to-transparent blur-3xl"></div>
      <div className="absolute -bottom-1/4 -right-1/4 w-1/2 h-1/2 bg-gradient-radial from-sky-100/80 to-transparent blur-3xl"></div>
      <div
        className="absolute inset-0 transition-all duration-300 ease-out"
        style={interactiveGradientStyle}
      ></div>
    </div>
  );
};

export default Background